/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MagellanLogoColored } from 'library';
import lightBulbImage from 'assets/img/error_light_bulb.png';

const LightBulbBackground = styled('img')(({ theme }) => ({
  position: 'absolute',
  right: '25%',
  top: '5%',
  width: 800,
  [theme.breakpoints.up('sm')]: {
    right: '35%',
    width: 1000,
  },
  [theme.breakpoints.up('md')]: {
    right: '44%',
    width: 1080,
  },
}));

const ErrorScreen = () => {
  const onButtonClick = action => {
    if (action === 'back') {
      window.location.reload();
    } else {
      window.location.replace('/');
    }
  };

  const supportContact = 'commercialtechnology@magellanlp.com';

  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'), { noSsr: true });
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'surface.light',
        display: 'flex',
        flexDirection: 'column',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        height: { xs: 'calc(100vh - 56px)', md: 'calc(100vh - 48px)' },
        justifyContent: 'center',
        position: 'relative',
        width: '100vw',
      }}
    >
      <LightBulbBackground alt="Shattered light bulb error message" src={lightBulbImage} />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: { xs: 24, md: 'unset' },
          padding: { xs: 3, md: 'unset' },
          textAlign: { xs: 'center', md: 'unset' },
          zIndex: 1,
        }}
      >
        <Typography sx={{ mb: 4 }} variant={mdUp ? 'h3' : 'h4'}>
          Sorry, something went wrong.
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            hyphens: 'none',
          }}
          variant="h6"
        >
          Please click on an option below to try your request again.
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            hyphens: 'none',
          }}
          variant="h6"
        >
          If you continue to experience this issue please call our support team at{' '}
          <Typography component="span" noWrap>
            {supportContact}
          </Typography>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            marginTop: { xs: 2, md: 'unset' },
          }}
        >
          <Button
            onClick={() => onButtonClick('back')}
            sx={{
              mx: { xs: 0, md: 2 },
              my: { xs: 1, md: 4 },
              minWidth: 150,
            }}
            variant="outlined"
          >
            Go Back A Page
          </Button>
          <Button
            onClick={() => onButtonClick('home')}
            sx={{
              mx: { xs: 0, md: 2 },
              my: { xs: 1, md: 4 },
              minWidth: 150,
            }}
            variant="outlined"
          >
            Return Home
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          bottom: { md: 64 },
          display: { xs: 'none', md: 'unset' },
          left: { md: 'calc(50% - 113px)' },
          position: { md: 'absolute' },
          width: { md: 226 },
        }}
      >
        <MagellanLogoColored sx={{ width: '100%' }} />
      </Box>
    </Box>
  );
};

export default ErrorScreen;
